export default __webpack_public_path__ + "images/911885199b89e6eb1c0c79b964f6bf61-eu_msmt.png";